exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse-item .card-header{cursor:pointer}.collapse-item .card-header-icon{transition:transform .377s ease}.collapse-item .card-content{padding-top:0;padding-bottom:0;overflow:hidden}.collapse-item .card-content-box{padding-top:20px;padding-bottom:20px}.collapse-item.is-active>.card-header>.card-header-icon{transform:rotate(90deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1996f2c4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/front/components/GeneralComponents/vue-bulma-collapse/Item.vue
// module id = rV3U
// module chunks = 1